import ContentHead from "./ContentHead";

export default function Interests() {
  return (
    <div className="p-4">
      <ContentHead title="Participations" />
      <div className="">
        <p className="m-0 font-size-md text-gray-600 mr-2 mb-3">
          October 2022 : Participation in the 9th edition of Devoxx Morocco.
        </p>
        <p className="m-0 font-size-md text-gray-600 mr-2 mb-3">
          2018 - 2020 : {""}
          <a
            href="https://www.youtube.com/watch?v=O0lk8Mn1rz0"
            target="_blank"
            rel="noopener noreferrer"
          >
            BMCE
          </a>
          ,{" "}
          <a
            href="https://www.youtube.com/watch?v=G-PYNFNQBWM"
            target="_blank"
            rel="noopener noreferrer"
          >
            RAM
          </a>
          ,{" "}
          <a
            href="https://www.youtube.com/watch?v=OgLUply4bE4"
            target="_blank"
            rel="noopener noreferrer"
          >
            ONEE
          </a>
          ,{" "}
          <a
            href="https://www.youtube.com/watch?v=bqSgsjKIyow"
            target="_blank"
            rel="noopener noreferrer"
          >
            ONCF
          </a>{" "}
          Hackathons as an expert Screendy and organizer.
        </p>
        <p className="m-0 font-size-md text-gray-600 mr-2 mb-3">
          2018 - 2020 :{" "}
          <a
            href="https://www.youtube.com/watch?v=xZj5ZIEatLA/"
            target="_blank"
            rel="noopener noreferrer"
          >
            HPS
          </a>
          , PSA Bootcamps as an expert Screendy and organizer.
        </p>
        <p className="m-0 font-size-md text-gray-600 mr-2 mb-3">
          2018 - 2020 : Demo days, Project Scalerators Sessions .. .
        </p>
      </div>
      <ContentHead title="Interests" />
      <div className="d-flex">
        <p className="m-0 font-size-md text-gray-600 mr-2">Embrodery, </p>
        <p className="m-0 font-size-md text-gray-600 mr-2">Traveling, </p>
        <p className="m-0 font-size-md text-gray-600 mr-2">Ping Pong,</p>
        <p className="m-0 font-size-md text-gray-600 mr-2">
          Fictional & competitive games .
        </p>
      </div>
    </div>
  );
}
